import React, { useState } from "react";
import "./switch.css";

const ToggleSwitch = ({ id, toggleSwitchHandler }) => {
  const [active, setActive] = useState(false);

  const handleChange = () => {
    setActive(!active);
    toggleSwitchHandler(id, active);
  };

  return (
    <label className="switch">
      <input type="checkbox" value={active} onChange={handleChange} />
      <span className="slider round"></span>
    </label>
  );
};

export default ToggleSwitch;
